module.exports = __webpack_public_path__ + "static/media/icon-success.4e68db03.png";